import { styled } from '@linaria/react';

import { colors, fonts, space } from '../../theme/tokens';

export const ContentColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${space[8]};
  width: 100%;
  min-height: 0;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
  width: 100%;
`;

export const HeadingBlock = styled.div`
  text-align: center;
`;

export const Heading = styled.h2`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
  margin: 0;
  line-height: 1.2;
`;

export const HeadingAccent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${colors.fontSecondary};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const FormError = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${colors.error};
  text-align: center;
`;

export const BackRow = styled.div`
  text-align: center;
  margin-top: ${space[2]};
`;

export const SuccessMessage = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  color: ${colors.fontPrimary};
  text-align: center;
  line-height: 1.6;
  margin: 0;
  width: 100%;
`;
